var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import deepmerge from 'deepmerge';
import { IconsProvider, VideoIcon } from '@shapeable/icons';
import { EntityConfigProvider, defaultEntityConfig } from '../providers/entity-config-provider';
import { ComponentPropsProvider } from './component-props-context';
import { SiteMenuBarProvider, defaultSiteMenuBarConfig } from './site-menu-bar-context';
import { SiteSidebarProvider, defaultSiteSidebarConfig } from './site-sidebar-context';
import { LangStringsProvider, defaultLangStrings } from './lang-strings-context';
import { LayoutsProvider, defaultLayoutsContextValue } from './layouts-context';
import { EmbedComponentsProvider } from './embed-components-context';
import { VideoIconProvider } from './video-icon-context';
import { ThemeProvider } from './theme-context';
import { PageEntityChildrenProvider } from './page-entity-children-context';
import { EntityTypeConfigProvider, defaultEntityTypeConfig } from './entity-type-config-context';
import { CookieBannerFeaturesList } from '../elements/cookie-banner-features-list';
import { CookieBannerFeaturesListProvider } from './cookie-banner-features-list-context';
import { defaultSiteSearchConfig, SiteSearchProvider } from './site-search-context';
import { defaultSiteHeaderConfig, SiteHeaderProvider } from './site-header-context';
import { defaultSiteFooterConfig, SiteFooterProvider } from './site-footer-context';
import * as baseSliceLayouts from '../slice-layouts';
import * as baseIndicatorLayouts from '../indicator-layouts';
import * as baseIndicatorGroupLayouts from '../indicator-group-layouts';
import { ActiveMode } from './theme-mode-context';
import { defaultExplorerConfig, ExplorerProvider } from './explorer-context';
import { FormStateProvider } from './form-state-context';
// todo - add more sub providers?
export var defaultUiConfig = {
  entity: defaultEntityConfig,
  entityType: defaultEntityTypeConfig,
  theme: {},
  themeName: 'DEFAULT_THEME',
  icons: {},
  search: defaultSiteSearchConfig,
  componentProps: {},
  header: defaultSiteHeaderConfig,
  footer: defaultSiteFooterConfig,
  menuBar: defaultSiteMenuBarConfig,
  sidebar: defaultSiteSidebarConfig,
  explorer: defaultExplorerConfig,
  layouts: __assign(__assign({}, defaultLayoutsContextValue), {
    sliceLayouts: __assign(__assign({}, baseSliceLayouts), (defaultLayoutsContextValue === null || defaultLayoutsContextValue === void 0 ? void 0 : defaultLayoutsContextValue.sliceLayouts) || {}),
    indicatorLayouts: __assign(__assign({}, baseIndicatorLayouts), (defaultLayoutsContextValue === null || defaultLayoutsContextValue === void 0 ? void 0 : defaultLayoutsContextValue.indicatorLayouts) || {}),
    indicatorGroupLayouts: __assign(__assign({}, baseIndicatorGroupLayouts), (defaultLayoutsContextValue === null || defaultLayoutsContextValue === void 0 ? void 0 : defaultLayoutsContextValue.indicatorGroupLayouts) || {})
  }),
  langStrings: defaultLangStrings,
  embeds: {},
  videoIcon: VideoIcon,
  cookieBannerFeaturesList: React.createElement(CookieBannerFeaturesList, null)
};
export var UiProvider = function (_a) {
  var value = _a.value,
    children = _a.children;
  var config = deepmerge(defaultUiConfig, value || {});
  return React.createElement(ThemeProvider, {
    theme: config.themeName,
    overrides: config.theme
  }, React.createElement(ActiveMode, null, React.createElement(FormStateProvider, null, React.createElement(ExplorerProvider, {
    value: config.explorer
  }, React.createElement(CookieBannerFeaturesListProvider, {
    value: config.cookieBannerFeaturesList
  }, React.createElement(VideoIconProvider, {
    value: config.videoIcon
  }, React.createElement(IconsProvider, {
    value: config.icons
  }, React.createElement(EntityTypeConfigProvider, {
    value: config.entityType
  }, React.createElement(EntityConfigProvider, {
    value: config.entity
  }, React.createElement(ComponentPropsProvider, {
    value: config.componentProps
  }, React.createElement(LangStringsProvider, {
    value: config.langStrings
  }, React.createElement(SiteSearchProvider, {
    value: config.search
  }, React.createElement(SiteMenuBarProvider, {
    value: config.menuBar
  }, React.createElement(SiteSidebarProvider, {
    value: config.sidebar
  }, React.createElement(EmbedComponentsProvider, {
    value: config.embeds
  }, React.createElement(LayoutsProvider, {
    value: config.layouts
  }, React.createElement(PageEntityChildrenProvider, {
    value: config.pageEntityChildren
  }, React.createElement(SiteHeaderProvider, {
    value: config.header
  }, React.createElement(SiteFooterProvider, {
    value: config.footer
  }, children)))))))))))))))))));
};